"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowCountPicker = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var RowCountPicker = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .result-dropdown {\n        -webkit-appearance: none;\n        background-color: #fff;\n        background-image: url(data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBmaWxsPSIjMzM4Y2U0IiBkPSJNNDQxLjkgMTY3LjNsLTE5LjgtMTkuOGMtNC43LTQuNy0xMi4zLTQuNy0xNyAwTDIyNCAzMjguMiA0Mi45IDE0Ny41Yy00LjctNC43LTEyLjMtNC43LTE3IDBMNi4xIDE2Ny4zYy00LjcgNC43LTQuNyAxMi4zIDAgMTdsMjA5LjQgMjA5LjRjNC43IDQuNyAxMi4zIDQuNyAxNyAwbDIwOS40LTIwOS40YzQuNy00LjcgNC43LTEyLjMgMC0xN3oiPjwvcGF0aD48L3N2Zz4=);\n        background-repeat: no-repeat;\n        background-size: 10px;\n        background-position: right 5px center;\n        min-width: 30px;\n        padding: 0.1rem 1rem 0.1rem 0.5rem;\n        border: 1px solid #000000;\n        color: #000000;\n    }\n"])));

exports.RowCountPicker = RowCountPicker;